/* eslint-disable @typescript-eslint/no-explicit-any */
import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommmonService } from 'src/app/utils/common.service';
import { PageStateService } from 'src/app/components/paginator/page-state.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
})
export class CategoriesComponent implements OnInit {
  isExpanded = true;
  isSizeMobile = false;
  categories: any = [];
  plans: any = [];
  antiques: any = [ 0,1, 2, 3, 10];
  beneficiaryTypes: any = [];
  selectedAntiquies: any = [];
  selectedPlans: any = [];
  selectedBeneficiaryTypes: any = [];
  selectedBeneficiaryAntiques:any=[];
  public countBenefit = 0;
  iconColor = '';
  expandPlan = false;
  checkSelectedfromBeforePlan: any[] = [];
  expandTypes = false;
  checkSelectedfromBeforeTypes: any[] = [];
  checkSelectedfromBeforeAntiques: any[] = [];
  expandAntiques = false;
  selectedCategory: number | null = -1;

  @Output() filterClose = new EventEmitter<boolean>();
  @Output() dataSended = new EventEmitter<any>();

  constructor(
    private breakpointObserver: BreakpointObserver,
    private commonService: CommmonService,
    private pageStateService: PageStateService,
    private route: ActivatedRoute,
  ) {}

  async ngOnInit(): Promise<void> {
    await this.getFilters();
    this.memoryCheckPlan();
    this.memoryCheckTypes();
    this.memoryCheckAntiques()
    this.memoryCategories()
    const oritentation = this.breakpointObserver.observe([
      '(max-width: 768px)',
    ]);
    oritentation.subscribe((lay) => {
      this.isSizeMobile = lay.breakpoints['(max-width: 768px)'];
      if (this.isSizeMobile) {
        this.isExpanded = true;
      }
    });
  }

  closeFilter() {
    this.filterClose.emit(false);
  }

  filterBenefitsByCategory(data: any) {
    this.selectedCategory = data.idcategory;
    this.pageStateService.selected_category = data.idcategory;

    data.type = 'category';
    this.dataSended.emit(data);
  }

  filterBenefitsByAntiquity(event: any) {
    if (event.target.checked) {
      this.selectedAntiquies.push(parseInt(event.target.id)); 
    } else {
      this.selectedAntiquies = this.selectedAntiquies.filter(
        (sa: any) => sa !== parseInt(event.target.id),
      );
    }
    this.pageStateService.filterAntiquesIdChecked = this.selectedAntiquies;
    this.pageStateService.usedFilterPanelValidAntiques = this.selectedAntiquies.length > 0;

    const data = {
      type: 'antiquity',
      values: this.selectedAntiquies,
    };
    this.dataSended.emit(data);
  }

  filterBenefitsByPlan(event: any) {
    if (event.target.checked) {
      this.selectedPlans.push(parseInt(event.target.id));
    } else {
      this.selectedPlans = this.selectedPlans.filter(
        (sa: any) => sa !== parseInt(event.target.id),
      );
    }
    this.pageStateService.filterplanIdchecked = this.selectedPlans;
    this.pageStateService.usedFilterPanelValidPlan = this.selectedPlans.length > 0;

    const data = {
      type: 'plan',
      values: this.selectedPlans,
    };
    this.dataSended.emit(data);
  }

  filterBenefitsByBeneficiaryTypes(event: any) {
    if (event.target.checked) {
      this.selectedBeneficiaryTypes.push(parseInt(event.target.id));      
    } else {
      this.selectedBeneficiaryTypes = this.selectedBeneficiaryTypes.filter(
        (sa: any) => sa !== parseInt(event.target.id),
      );
    }
    
    this.pageStateService.filterTypeidChecked = this.selectedBeneficiaryTypes;
    this.pageStateService.usedFilterPanelValidTypes = this.selectedBeneficiaryTypes.length > 0;

    const data = {
      type: 'beneficiaryType',
      values: this.selectedBeneficiaryTypes,
    };
    this.dataSended.emit(data);
  }

  async getFilters() {
    this.categories = this.commonService.sortArray(
      this.route.snapshot.data['resolverCategory'] ?? [],
    );
    this.plans = this.commonService.sortArray(
      this.route.snapshot.data['resolverPlans'] ?? [],
    );
    this.beneficiaryTypes = this.commonService.sortArray(
      this.route.snapshot.data['resolverTypeBenef'] ?? [],
    );
    this.countBenefit = JSON.parse(
      this.commonService.getItemLocalStorage('benefits') ?? '[]',
    ).length;

    this.commonService.removeItemLocalStorage('categories');
    this.commonService.removeItemLocalStorage('plans');
    this.commonService.removeItemLocalStorage('beneficiaryTypes');

    this.commonService.setItemLocalStorage(
      'categories',
      JSON.stringify(this.categories),
    );
   
    this.commonService.setItemLocalStorage('plans', JSON.stringify(this.plans));
    this.commonService.setItemLocalStorage(
      'beneficiaryTypes',
      JSON.stringify(this.beneficiaryTypes),
    );
  }
memoryCategories() {
    this.selectedCategory = this.pageStateService.selected_category !== undefined && this.pageStateService.selected_category !== null
      ? this.pageStateService.selected_category 
      : -1;
  }
  

  memoryCheckPlan() {
    if (this.pageStateService.usedFilterPanelValidPlan) {
      this.expandPlan = true;
      this.checkSelectedfromBeforePlan =
        this.pageStateService.filterplanIdchecked;
      this.selectedPlans = this.checkSelectedfromBeforePlan;
    }
  }

  memoryCheckTypes() {
    if (this.pageStateService.usedFilterPanelValidTypes) {
      this.expandTypes = true;
      this.checkSelectedfromBeforeTypes =
        this.pageStateService.filterTypeidChecked;
      this.selectedBeneficiaryTypes = this.checkSelectedfromBeforeTypes;
    }
  }

  memoryCheckAntiques() {
    if (this.pageStateService.usedFilterPanelValidAntiques) {
      this.expandAntiques = true;
      this.checkSelectedfromBeforeAntiques =
        this.pageStateService.filterAntiquesIdChecked;
      this.selectedAntiquies = this.checkSelectedfromBeforeAntiques;
    }
  }

  antiguedad(antiques:number){  
    if(antiques === 1){
      return `Desde ${antiques} año de antigüedad`
      }
      if(antiques < 1){
      return 'Sin antigüedad'
    }else{
      return`Desde ${antiques} años de antigüedad`
    }
  }
}
